export enum Updates {
    AUTOMATIC_UPDATE = "Ha rechazado la actualización más de las veces permitidas, se actualizará automáticamente en 30 segundos, guarde su trabajo.",
    DISMISSION_MESSAGE = "La actualización será aplazada por 5 minutos. Podrá aplazarla máximo %u %s más.",
    NO_DISMISSABLE = "La actualización será aplazada por 5 minutos. No podrá aplazarla nuevamente"
}
